<template>
  <div :style="`width: ${width}`">
    <div class="primary-text">
      <span :class="titleClass" v-html="contactName"></span>
    </div>
    <div class="d-flex justify-start">
      <v-chip small label outlined text-color="primary" style="height: 21px;"
        @click="callNumber({ number: voicemail.callerNum })">
        <span class="font-weight-medium">
          {{ voicemail.callerNum | formatPhoneNum(countryCode) }}
        </span>
      </v-chip>
      <v-btn v-if="displayAddToContactsButton" icon class="ml-1"
        @click="addToContacts($event)" height="21" width="25">
        <v-icon color="primary" small>mdi-account-plus</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'
import Contact from 'Store/class/contact/contact'

export default {
  name: 'voicemails-msg-caller-number',
  props: {
    voicemail: {
      type: Object,
      required: true
    },
    usedInList: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      countryCode: 'countryCode',
      canWriteContacts: 'permissions/contactsWrite',
      canWritePersonalContacts: 'permissions/contactsManagePersonal',
      phoneNumbers: 'contacts/phoneNumbers/phoneNumbers'
    }),
    contact () {
      return this.phoneNumbers?.find((phone) => parseInt(phone.phoneNumber) === parseInt(this.voicemail?.callerNum))
    },
    displayAddToContactsButton () {
      return (this.canWriteContacts || this.canWritePersonalContacts) && !this.contact
    },
    contactName () {
      return this.contact ? this.contact.name : this.voicemail?.callerName
    },
    titleClass () {
      return this.voicemail.isRead ? '' : 'font-weight-bold'
    },
    isOnMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    width () {
      if (this.usedInList) {
        return 'auto'
      } else {
        return this.isOnMobile ? '150px' : '300px'
      }
    }
  },
  methods: {
    ...mapActions({
      openContactForm: 'contacts/form/open',
      callNumber: 'callNumber'
    }),
    addToContacts (event) {
      event.stopPropagation()
      const isUpdate = false
      const contact = new Contact({})
      contact.isPersonal = false
      if (this.canWritePersonalContacts) {
        contact.isPersonal = true
      }
      contact.phoneNumbers[0].phone_number = this.voicemail?.callerNum
      contact.lastName = this.voicemail?.callerName
      this.openContactForm({ contact, isUpdate })
    }
  }
}
</script>

<style scoped>
</style>
